// Consent gate for third-party analytics. Today this is always-allow so behavior
// matches what we shipped before unification. When GDPR work begins, swap the
// implementation here (read from a user-preferences store) — every dispatch
// path in the tracking module gates on this single function, so no call sites
// need to change.

export type ConsentCategory = 'analytics';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getAnalyticsConsent = (_category: ConsentCategory = 'analytics'): boolean => {
	return true;
};
